import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useLocation } from 'react-router-dom';

const WhatsAppButton = () => {
  const { pathname } = useLocation();
  const whatsappNumber = '917827327243'; // +91 7827 327 243
  const defaultMessage = 'Hi! I would like to know more about Delhi Guided Tours.';
  
  const handleClick = () => {
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(defaultMessage)}`;
    window.open(url, '_blank');
  };

  if (pathname === '/weekend-tour') return null;

  return (
    <button
      onClick={handleClick}
      className="whatsapp-float"
      aria-label="Contact us on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <MessageCircle size={28} />
    </button>
  );
};

export default WhatsAppButton;